// extracted by css-extract-rspack-plugin
export default {"contextKindLabel":"bMnKj7Q0Wjo2WsZ_","stacked":"Usf_zKlPkvY2QXJb","inline":"E7xW2kcl2eUDxVYI","name":"RfsLQKITBk4EWlmz"};